var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          ref: "drawerRef",
          attrs: {
            visible: _vm.drawerVisible,
            direction: "ltr",
            "with-header": false,
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
            close: _vm.cancelDrawer,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                margin: "40px 20px",
              },
            },
            [
              _c("div", [
                _c("span", { staticClass: "dn_title" }, [
                  _vm._v(_vm._s(_vm.drawerTitleName)),
                ]),
                _vm.drawerCode
                  ? _c("span", { staticClass: "dn_code" }, [
                      _vm._v(_vm._s(_vm.drawerCode)),
                    ])
                  : _vm._e(),
              ]),
              _c("span", {
                staticClass: "el-icon-close dn_close",
                on: { click: _vm.cancelDrawer },
              }),
            ]
          ),
          _c(
            "div",
            {
              staticStyle: {
                "padding-left": "20px",
                "padding-right": "20px",
                "box-sizing": "border-box",
              },
            },
            [
              _c(
                "el-divider",
                {
                  staticClass: "divider_line_class",
                  attrs: { "content-position": "left" },
                },
                [_vm._v(_vm._s(_vm.$t("newOrder.BasicInformation")))]
              ),
              _c(
                "el-form",
                {
                  ref: "formRef",
                  staticClass: "selectClass",
                  attrs: { model: _vm.detailForm },
                },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        "justify-content": "space-around",
                        "align-items": "center",
                        "flex-wrap": "wrap",
                      },
                      attrs: { type: "flex" },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("collectionCenter.module"),
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t(
                                      "collectionCenter.pleaseChoose"
                                    ),
                                    trigger: ["blur", "change"],
                                  },
                                ],
                                prop: "moduleId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseChoose"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    disabled: _vm.opType === 3,
                                  },
                                  on: { change: _vm.changeModule },
                                  model: {
                                    value: _vm.detailForm.moduleId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "moduleId", $$v)
                                    },
                                    expression: "detailForm.moduleId",
                                  },
                                },
                                _vm._l(_vm.moduleData, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("navbar.menu"),
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t(
                                      "collectionCenter.pleaseChoose"
                                    ),
                                    trigger: ["blur", "change"],
                                  },
                                ],
                                prop: "menuId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "navbar.pleaseSelectModule"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    disabled:
                                      _vm.detailForm.moduleId === "" ||
                                      _vm.opType === 3,
                                  },
                                  model: {
                                    value: _vm.detailForm.menuId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "menuId", $$v)
                                    },
                                    expression: "detailForm.menuId",
                                  },
                                },
                                _vm._l(_vm.menuData, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("trajectory.state"),
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t(
                                      "collectionCenter.pleaseChoose"
                                    ),
                                    trigger: ["blur", "change"],
                                  },
                                ],
                                prop: "status",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseChoose"
                                    ),
                                    disabled: _vm.opType === 3,
                                  },
                                  model: {
                                    value: _vm.detailForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "status", $$v)
                                    },
                                    expression: "detailForm.status",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.enable"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.stop"),
                                      value: 0,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 10 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-divider",
                {
                  staticClass: "divider_line_class",
                  attrs: { "content-position": "left" },
                },
                [_vm._v(_vm._s(_vm.$t("navbar.documentInfo")))]
              ),
              _c(
                "div",
                { staticStyle: { margin: "0 auto" } },
                [
                  _vm.opType !== 3
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.addRowClick },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.add")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-form",
                    { ref: "tableRef", attrs: { model: _vm.tableForm } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-radius": "0 !important",
                          },
                          attrs: {
                            data: _vm.tableForm.tableList,
                            "header-cell-style": {
                              background: "#f2f2f2",
                              color: "black",
                            },
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("dictionary.language"),
                              prop: "language",
                              align: "center",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  var $index = ref.$index
                                  return [
                                    _vm.opType === 3
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              row.language === "zh-CN"
                                                ? "中文"
                                                : row.language === "pt-BR"
                                                ? "Português"
                                                : ""
                                            )
                                          ),
                                        ])
                                      : _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "tableList." +
                                                $index +
                                                ".language",
                                              rules: _vm.rules.language,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "collectionCenter.pleaseChoose"
                                                  ),
                                                  clearable: "",
                                                  filterable: "",
                                                },
                                                model: {
                                                  value: row.language,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      row,
                                                      "language",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.language",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "中文",
                                                    value: "zh-CN",
                                                  },
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "Português",
                                                    value: "pt-BR",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("navbar.documentName"),
                              prop: "documentName",
                              align: "center",
                              "min-width": "200",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  var $index = ref.$index
                                  return [
                                    _vm.opType === 3
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-tooltip",
                                              { attrs: { placement: "top" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "max-height": "200px",
                                                      overflow: "auto",
                                                      "max-width": "500px",
                                                    },
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(row.documentName)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "paramsStyle",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(row.documentName)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "tableList." +
                                                $index +
                                                ".documentName",
                                              rules: _vm.rules.documentName,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                clearable: "",
                                                placeholder: _vm.$t(
                                                  "collectionCenter.pleaseInput"
                                                ),
                                              },
                                              model: {
                                                value: row.documentName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "documentName",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.documentName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("basicData.fileName"),
                              prop: "fileName",
                              align: "center",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "max-height": "200px",
                                              overflow: "auto",
                                              "max-width": "500px",
                                            },
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [_vm._v(_vm._s(row.fileName))]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "paramsStyle" },
                                          [_vm._v(_vm._s(row.fileName))]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("basicData.LatestVersion"),
                              prop: "currentVersionName",
                              align: "center",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    !row.id
                                      ? _c("div", [
                                          _vm._v(
                                            _vm._s(row.currentVersionName)
                                          ),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "version_class",
                                            on: {
                                              click: function ($event) {
                                                _vm.totalCount(
                                                  row,
                                                  _vm.$t(
                                                    "navbar.historicalVersionQuery"
                                                  ),
                                                  2
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(row.currentVersionName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("trajectory.state"),
                              prop: "status",
                              align: "center",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    row.status === 1
                                      ? _c(
                                          "span",
                                          { staticClass: "state_class green" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("basicData.Effective")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    row.status === 0
                                      ? _c(
                                          "span",
                                          { staticClass: "state_class red" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "basicData.Ineffective"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm.opType !== 1
                            ? _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.Updater"),
                                  prop: "updateUserName",
                                  align: "center",
                                  "min-width": "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(row.updateUserName) +
                                                " "
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  674621172
                                ),
                              })
                            : _vm._e(),
                          _vm.opType !== 1
                            ? _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.UpdateTime"),
                                  prop: "updateTime",
                                  align: "center",
                                  "min-width": "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _vm._v(
                                              " " + _vm._s(row.updateTime) + " "
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2477166647
                                ),
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("collectionCenter.operation"),
                              align: "center",
                              width: _vm.operationWidth,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  var $index = ref.$index
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.opType !== 3 && !row.id,
                                            expression:
                                              "opType !== 3 && !row.id",
                                          },
                                        ],
                                        staticClass: "btn_sum",
                                        staticStyle: { "margin-bottom": "5px" },
                                        attrs: {
                                          size: "small",
                                          round: "",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openUpload($index)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("collectionCenter.Upload")
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.opType !== 3 && row.id,
                                            expression:
                                              "opType !== 3 && row.id",
                                          },
                                        ],
                                        staticClass: "btn_sum",
                                        staticStyle: { "margin-bottom": "5px" },
                                        attrs: {
                                          size: "small",
                                          round: "",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openUpload($index)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("navbar.updateVersion"))
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: row.fileUrl,
                                            expression: "row.fileUrl",
                                          },
                                        ],
                                        staticClass: "btn_sum",
                                        staticStyle: { "margin-bottom": "5px" },
                                        attrs: {
                                          size: "small",
                                          round: "",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.preViewFile(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("operationCenter.Preview")
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: row.fileUrl,
                                            expression: "row.fileUrl",
                                          },
                                        ],
                                        staticClass: "btn_sum",
                                        staticStyle: { "margin-bottom": "5px" },
                                        attrs: {
                                          size: "small",
                                          round: "",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadFile(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("GlobalSetObj.Download")
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.opType !== 3 &&
                                              row.status === 1,
                                            expression:
                                              "opType !== 3 && row.status === 1",
                                          },
                                        ],
                                        staticClass: "btn_sum",
                                        staticStyle: { "margin-bottom": "5px" },
                                        attrs: {
                                          size: "small",
                                          round: "",
                                          type: "danger",
                                        },
                                        on: {
                                          click: function ($event) {
                                            row.status = 0
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("basicData.Ineffective")
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.opType !== 3 &&
                                              row.status === 0,
                                            expression:
                                              "opType !== 3 && row.status === 0",
                                          },
                                        ],
                                        staticClass: "btn_sum",
                                        staticStyle: { "margin-bottom": "5px" },
                                        attrs: {
                                          size: "small",
                                          round: "",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            row.status = 1
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("basicData.Effective"))
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.opType !== 3,
                                            expression: "opType !== 3",
                                          },
                                        ],
                                        staticClass: "btn_sum",
                                        staticStyle: { "margin-bottom": "5px" },
                                        attrs: {
                                          size: "small",
                                          round: "",
                                          type: "danger",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delRow($index)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("GlobalSetObj.Delete"))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.opType !== 3
                ? _c(
                    "div",
                    { staticStyle: { padding: "20px", "text-align": "right" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.cusSubmit(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.cusSubmit(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("customerManagements.Save")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "upld_box",
          attrs: {
            title: _vm.$t("collectionCenter.Upload"),
            visible: _vm.uploadShow,
            center: "",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.uploadShow = $event
            },
          },
        },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                drag: "",
                action: "",
                "file-list": _vm.fileList,
                "before-upload": _vm.beforeUpload,
                "http-request": _vm.Upload,
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v(
                  _vm._s(_vm.$t("basicData.DragTheFileHereOrClickUpload"))
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [_vm._v(_vm._s(_vm.$t("navbar.fileUploadRestrictions")))]
              ),
            ]
          ),
        ],
        1
      ),
      _c("dialogChild", { ref: "dialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }